import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CustomPaggerService } from '../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { SecureStorage } from '../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from '../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from '../../../../../Autofacets-Core/src/app/utils/constant';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { KeyDropLocationViewModel } from '../../business-entities/dealer-keydrop-location-view-model';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { KeyDropLocationService } from '../../business-services/dealer-keyDrop-location.service';
import { DealerSearchService } from '../../business-services/dealer-serach.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { AddDealerKeydropLocationComponent } from './add-dealer-keydrop-location/add-dealer-keydrop-location.component';
import { EditDealerKeydropLocationComponent } from './edit-dealer-keydrop-location/edit-dealer-keydrop-location.component';
import { AdminCommonService } from '../../services/admin-common.service';

@Component({
  selector: 'app-dealer-keydrop-location',
  templateUrl: './dealer-keydrop-location.component.html'
})
export class DealerKeydropLocationComponent implements OnInit, OnDestroy {
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  popupCloseResult = false;
  keyDropLocation: KeyDropLocationViewModel[];
  locationList: SelectListItemViewModel[];

  keyDropLocationSub: Subscription;
  selectedDealerId: string = '';
  focus$ = new Subject<string>();
  userRoleRightsDetails: UserRoleMenu;
  dealerList: Array<SelectListItemViewModel>;
  constructor(
    private adminCommonService : AdminCommonService,
    public pService: CustomPaggerService,
    public dealerBusinessService: DealerBusinessService,
    private secureStorage: SecureStorage,
    private router: Router,
    private modalService: NgbModal,
    private service: KeyDropLocationService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private userService: UserDataService,
    private dealerService: DealerSearchService,
    config: NgbModalConfig,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['locationName', 'dealerName', 'locationTypeName'];
    this.pService.searchTerm = '';
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);

    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.selectedDealerId = this.userService.currentUserValue.defaultDealerId;
    this.service.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.pService.dataSource = [];
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.DealerKeydropLocation);
    this.Methods();
    this.getUserDealers();
    this.checkId();
    this.focus$.subscribe(x => {
      if (x.length === 0) {
        this.service.dealerId = '';
        this.getKeyDropLocation(this.service.dealerId);
      }
    });
  }

  checkId() {
    if (this.service.isEdit && this.service.dealerId) {
      this.selectedDealerId = this.service.dealerId;
    }
    this.service.isEdit = false;
    this.getKeyDropLocation(this.selectedDealerId);
  }

  async Methods() {
    this.spinner.show();
    await this.getLocationList();
    this.spinner.hide();
  }

  onDealerSelected(dealerId: string) {
    this.service.dealerId = dealerId;
    this.selectedDealerId = dealerId;
    this.getKeyDropLocation(this.selectedDealerId);
  }

  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.service.dealerList = this.dealerList;
    })
  }

  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async getKeyDropLocation(dealerId: string) {
    this.spinner.show();
    let Id = dealerId ?? '';
    await this.service.getKeyDropLocation(Id).then((response) => {
      this.spinner.hide();
      const responseObject = response.responseObject;
      const keyDropData = this.keyDropLocationDataMapper(responseObject);
      this.pService.dataSource = keyDropData;
      this.keyDropLocationSub = this.pService.dealers$.subscribe(result => {
        this.keyDropLocation = result;
      });
    }, _error => {
      this.spinner.hide();
    });
  }

  async getLocationList() {
    await this.service.getLocationList().then((result) => {
      this.locationList = result.responseObject;
    });
  }

  private keyDropLocationDataMapper(keyDropLocation: any) {
    let supperArray = [];
    if (keyDropLocation && keyDropLocation.length > 0) {

      for (let index = 0; index < keyDropLocation.length; index++) {
        const element = keyDropLocation[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.id = element.id
        single.dealerId = element.dealerId
        single.locationType = element.locationType
        single.locationTypeName = element.locationType && this.locationList ? this.locationList.find(x => x.value == element.locationType.toString()).text : ''
        single.locationName = element.locationName
        single.dealerName = element.dealerName
        single.isActive = element.isActive
        single.isDeleted = element.isDeleted
        single.isActive = element.isActive

        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onAdd() {
    const modalref = this.modalService.open(AddDealerKeydropLocationComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }

  onEdit(id: number) {
    this.service.KeydropLocationId = id;
    const modalref = this.modalService.open(EditDealerKeydropLocationComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });

  }

  onDelete(id: any) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblDealerKeyDrop"),false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.adminCommonService.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.service.deleteKeyDropLocation(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblDeleteKeydropLocation");
            this.toastr.success(successMsg)
            this.getKeyDropLocation(this.selectedDealerId);
          }
        });
      }
    });


  }

  ngOnDestroy(): void {
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    if (this.keyDropLocationSub) {
      this.keyDropLocationSub.unsubscribe();
    }
  }
}
